import Slider from "@material-ui/core/es/Slider/Slider";
import withStyles from "@material-ui/core/es/styles/withStyles";
import * as moment from "moment";
import React, {useContext, useEffect, useRef, useState} from "react";
import {SegmentedControl} from "segmented-control";
import {NavContext} from "./App";
import {useInterval} from "./components/hooks";
import {IconButton} from "./components/IconButton";
import VLButton from "./components/VLButton";
import * as API from "./util/api";
import * as Util from "./util/util";
import {useApi, VLScreen2} from "./views/VLScreen2";

const PrettoSlider = withStyles({
    root: {
        color: window.primary,
        height: 8
    },
    thumb: {
        height: 24,
        width: 24,
        backgroundColor: "#fff",
        border: "2px solid currentColor",
        marginTop: -8,
        marginLeft: -12,
        "&:focus, &:hover, &$active": {
            boxShadow: "inherit"
        }
    },
    track: {
        height: 8,
        borderRadius: 4
    },
    rail: {
        height: 8,
        borderRadius: 4
    }
})(Slider);

const TestScreen = ({id, heads, date, navigateToDay}) => {

    const [currentHead, setCurrentHead] = useState(0);
    const [previousHead, setPreviousHead] = useState(0);
    const [currentFrame, setCurrentFrame] = useState(0);

    const [isAutoPlaying, setIsAutoPlaying] = useState(false);
    const [isPlayingBackwards, setIsPlayingBackwards] = useState(false);

    const time = useInterval(100);

    const speedOptions = [0.2, 0.5, 1, 2, 4, 5, 10];
    const speedLabels = [5, 2, 1, 0.5, 0.25, 0.2, 0.1];
    const [speedOption, setSpeedOption] = useState(2);

    const autoPlayingFrameLength = 10 * speedOptions[speedOption];

    const fps = 30;

    const player = useRef(null);

    const selectedHead = heads[currentHead];
    const times = selectedHead.times;
    const videoSrc = selectedHead.video;

    const currentClockTime = times[currentFrame];

    const headOptions = heads.map((head, index) => ({
        label: head.headName,
        value: index,
        default: currentHead === index
    }));


    useEffect(() => {
        //set position again because the video src changed
        console.log("changing to " + selectedHead.headName + " from " + previousHead);
        const oldTimes = heads[previousHead].times;
        const newTimes = selectedHead.times;
        if (oldTimes.length === newTimes.length) {
            setPositionManual(currentFrame);
        } else {
            //scale the time
            const oldIndex = currentFrame;
            const fractionOfOld = oldIndex / oldTimes.length;
            const newIndex = Math.round(fractionOfOld * newTimes.length);
            setPositionManual(newIndex);
        }
        setPreviousHead(currentHead);
    }, [selectedHead]);

    const setPositionManual = pos => {
        if (pos < 0 || pos > times.length - 1) return;
        setCurrentFrame(pos);
        /* if (pos === times.length - 1) {
             player.current.currentTime = player.current.duration;
             console.log("goig to " + player.current.duration);
         } else {*/
        player.current.currentTime = pos / fps + 0.01;
        console.log("goig to " + pos / fps);
        // }
    };

    const togglePlaying = () => {
        if (isAutoPlaying && !isPlayingBackwards) {
            setIsAutoPlaying(false);
            return;
        }
        setIsAutoPlaying(true);
        setIsPlayingBackwards(false);
    };

    const togglePlayingBackwards = () => {
        if (isAutoPlaying && isPlayingBackwards) {
            setIsAutoPlaying(false);
            return;
        }
        setIsAutoPlaying(true);
        setIsPlayingBackwards(true);
    };

    const goFaster = () => {
        if (speedOption > 0) {
            setSpeedOption(e => e - 1);
        }
    };

    const goSlower = () => {
        if (speedOption < speedOptions.length - 1) {
            setSpeedOption(e => e + 1);
        }
    };

    useEffect(() => {
        if (isAutoPlaying && time % autoPlayingFrameLength === 0) {
            if (isPlayingBackwards) {
                setPositionManual(currentFrame - 1);
            } else {
                setPositionManual(currentFrame + 1);
            }
        }
    }, [time, autoPlayingFrameLength, isAutoPlaying]);

    const previousDay = () => {
        let unix = moment.unix(date).add(-1, "days").unix();
        navigateToDay(unix);
    };

    const nextDay = () => {
        let unix = moment.unix(date).add(1, "days").unix();
        if (unix > Util.rn()) {
            return;
        }
        navigateToDay(unix);
    };

    const downloadVideo = () => {
        const downloadUrl = "https://api.vision-link.co.uk/api3/systems/downloadVideo?url=" + encodeURIComponent(videoSrc);
        window.open(downloadUrl);
    };

    const downloadImage = () => {
        const time = times[currentFrame];
        API.POST("systems/getImage", {time: time, sensor_id: id}, result => {
            let src = result.result.image;
            window.open(Util.download(src));
        });
    };

    return (
        <div style={{display: "flex", flexDirection: "column", height: "calc(100vh - 64px)"}}>
            <div style={{flex: 1, overflow: "hidden", background: "black", width: "100%", textAlign: "center"}}>
                <video ref={player} src={videoSrc} style={{height: "100%"}}/>
            </div>
            {heads.length > 1 && (
                <div style={{margin: "0 64px"}}>
                    <SegmentedControl style={{color: window.primary}} options={headOptions} value={currentHead} setValue={setCurrentHead}/>
                </div>
            )}
            <div style={{margin: "0 64px"}}>
                <PrettoSlider style={{width: "100%"}}
                              value={currentFrame}
                              max={times.length - 1}
                              step={1}
                              onChange={(e, data) => {
                                  setPositionManual(data);
                              }}
                />
                <div style={{display: "flex", alignItems: "flex-end", justifyContent: "center", marginBottom: 20, flexWrap: "wrap"}}>
                    <div>
                        <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                            <IconButton icon="first_page" onClick={() => setPositionManual(0)}/>
                            <p>&nbsp;</p>
                            <IconButton icon={(isAutoPlaying && isPlayingBackwards) ? "pause" : "play_arrow"} iconClass="rotate-180" onClick={togglePlayingBackwards}/>
                            <h2 style={{margin: "0 16px"}}>Play</h2>
                            <IconButton icon={(isAutoPlaying && !isPlayingBackwards) ? "pause" : "play_arrow"} onClick={togglePlaying}/>
                        </div>
                    </div>

                    <p>&nbsp;</p>

                    <div>
                        <h2></h2>
                        <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                            <IconButton icon="fast_rewind" onClick={goSlower}/>
                            <p style={{width: 40, textAlign: "center"}}>{speedLabels[speedOption]}x</p>
                            <IconButton icon="fast_forward" onClick={goFaster}/>
                        </div>
                    </div>

                    <p>&nbsp;</p>

                    <div>
                        <h2/>
                        <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                            <VLButton style={{width: 180}} title="Previous Image" onClick={() => setPositionManual(currentFrame - 1)}/>
                            <h2 style={{margin: "0 16px"}}>{moment.unix(currentClockTime).format("HH:mm")}</h2>
                            <VLButton style={{width: 180}} title="Next Image" onClick={() => setPositionManual(currentFrame + 1)}/>
                        </div>
                    </div>

                    <p>&nbsp;</p>

                    <div>
                        <h2/>
                        <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                            <VLButton style={{width: 180}} title="Previous Day" onClick={previousDay}/>
                            <h2 style={{margin: "0 16px"}}>{moment.unix(date).format("DD/MM/YY")}</h2>
                            <VLButton style={{width: 180}} title="Next Day" onClick={nextDay}/>
                        </div>
                    </div>

                    <p>&nbsp;</p>

                    <div>
                        <h2/>
                        <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                            <VLButton style={{width: 180}} title="Download Image" onClick={downloadImage}/>
                            <p>&nbsp;</p>
                            <VLButton style={{width: 180}} title="Download Video" onClick={downloadVideo}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const NoResult = () => (
    <div style={{textAlign: "center", margin: 64}}>
        <h1 style={{margin: 32}}>No video is available for this date</h1>
        <VLButton title="Go back" onClick={() => window.history.back()}/>
    </div>
);

const Container = ({id, date}) => {

    const [loaded, error, data, reload] = useApi("systems/timeLapse", {id, date}, [id, date]);

    const navigate = useContext(NavContext).navigate;
    const navigateToDay = unix => navigate("/camera/" + id + "/timelapse/" + unix);

    return <VLScreen2 title={data.name} error={error} loaded={loaded} retry={reload} contentPadding={0}>
        {data.heads?.length > 0 && <TestScreen heads={data.heads} date={date} navigateToDay={navigateToDay} id={id}/>}
        {data.heads != null && data.heads.length === 0 && <NoResult/>}
    </VLScreen2>
};

export default Container;